import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faAward, faBrain } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Certifications.scss';

const certifications = [
  {
    title: "UX Researcher Courses",
    provider: "Udemy",
    year: "2025",
    icon: faCertificate,
    details: "Comprehensive coverage of research methods, usability testing, heuristic evaluation, and reporting user insights."
  },
  {
    title: "NLP Master Practitioner",
    provider: "CTAA Accredited",
    year: "2025",
    icon: faBrain,
    details: "Advanced understanding of cognitive patterns, communication frameworks, and user behavior modeling."
  },
  {
    title: "Art Therapy (Advanced)",
    provider: "Udemy",
    year: "2025",
    icon: faAward,
    details: "Completed 150+ lecture program applying expressive techniques to emotional design and user empathy."
  },
  {
    title: "Lay Counseling",
    provider: "KLE Lingaraj College",
    year: "2022",
    icon: faCertificate,
    details: "A+ grade. Foundations in active listening, rapport building, and structured emotional support."
  }
];

function Certifications() {
  return (
    <div id="certifications" className="container">
      <div className="certifications-container">
      <h1 className="certifications-title">
          <FontAwesomeIcon icon={faCertificate} className="title-icon" />
          Certifications & Achievements
        </h1>
        <div className="cert-grid">
          {certifications.map((c, i) => (
            <div className="cert-item" key={i}>
              <FontAwesomeIcon icon={c.icon} size="2x" className="cert-icon"/>
              <h3>{c.title}</h3>
              <p className="meta">{c.provider} · {c.year}</p>
              <p className="details">{c.details}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Certifications;